<template>
  <div>
    <Card >
      <Spinner v-if="loading || variableLoading" />
      <div v-else>
        <transition name="fade" >
          <ManageZIPVIN v-if="showManageZipVin"
            @close="showManageZipVin = false"
            @save="updateZipVin"
            :editable="isCreate || isEdit"
            :informative-campaign="campaign.config.userPreferences.onlyInformativeCampaign"
            :mvs="campaign.config.filters_exp.mvs.selected"
            :mvs-to-exclude="campaign.config.filters_exp.mvsToExclude.selected"
            :vin="campaign.config.userPreferences.onlyInformativeCampaign ? campaign.config.filters.vin.selected : campaign.config.filters_exp.vin.selected"
            :vin-to-exclude="campaign.config.userPreferences.onlyInformativeCampaign ? campaign.config.filters.vinToExclude.selected : campaign.config.filters_exp.vinToExclude.selected"
            :zipCodes="campaign.config.userPreferences.onlyInformativeCampaign ? campaign.config.filters.zipCodes.selected : campaign.config.filters_exp.zipCodes.selected"
          />
        </transition>
        <!-- common filters -->
        <Card v-if="!loading" additional-classes="slds-card_boundary" style="background: rgba(202, 174, 238, 0.39);
background: radial-gradient(circle, rgba(202, 174, 238, 0.486) 0%, rgba(148, 188, 233, 0.418) 100%);">
          <template v-if="campaign.config.userPreferences.onlyInformativeCampaign">
            <!-- <template slot="actions">
              <button class="slds-button slds-button_neutral" @click="showManageZipVin = true"> {{'Manage ZIP/VIN'}} </button>
            </template> -->
            <FiltersSet
                  ref="section"
                  @filterChanged="handleFilterChanged"
                  v-model="filters_exp"
                  :section-number="'4'"
                  :all-brands="allBrands"
                  :brands="allBrands"
                  :config="localConfig.filters_exp"
                  :isCreate="isCreate"
                  :isEdit="isEdit"
                  :loading="loading"
                  :exp="true"
                  :isCommon=true
                  :hasBothExFExP="hasBrandExF && hasBrandExP"
                  :campaignData="campaign.campaignData"
                  :userPreferences="campaign.config.userPreferences" />
          </template>
        <!-- Deduplication -->
        <hr>
        <Card :title="'Deduplication & Orchestration'" >
          <div class="row slds-m-top--medium">
            <div class="slds-form-element col slds-size--medium" >
              <template v-if="(isCreate || isEdit)">
                <div class="slds-form-element__control">
                  <div class="slds-checkbox">
                    <input type="checkbox" name="options" id="checkbox-deduplication" v-model="deduplicationEnabled"  />
                      <label class="slds-checkbox__label" for="checkbox-deduplication">
                      <span class="slds-checkbox_faux"></span>
                      <span class="slds-form-element__label">{{$t('campaignDesigner.targetDefinition.deduplication.label')}}</span>
                    </label>
                  </div>
                </div>
                <RadioGroup
                  :disabled="!deduplicationEnabled"
                  :options="deduplicationRadioOptions"
                  :validation="[{ name: 'conditional-required', param: deduplicationEnabled, message: 'validation.required'}]"
                  no-label
                  ref="data_deduplicationCriteria"
                  v-model="deduplicationCriteria" />

                <Picklist
                  :disabled="!deduplicationCriteria"
                  :options="deduplicationParameterOptions"
                  :validation="[{ name: 'conditional-required', param: deduplicationEnabled, message: 'validation.required'}]"
                  labels-prefix="campaignDesigner.targetDefinition.deduplication"
                  no-label
                  ref="data_deduplicationParameter"
                  v-model="deduplicationParameter" />


              </template>

              <template v-else>
                <OutputField :label="$t('campaignDesigner.targetDefinition.deduplication.label')" type="custom">
                  <span v-if="deduplicationCriteria">{{$t(`campaignDesigner.targetDefinition.deduplication.${deduplicationCriteria}`)}}</span>
                </OutputField>
                <OutputField no-label type="custom" v-if="deduplicationParameter">
                  {{$t(`campaignDesigner.targetDefinition.deduplication.${deduplicationParameter}`)}}
                </OutputField>
              </template>
            </div>
          </div>
          <!-- Orchestration -->
          <div class="row slds-m-top--medium" v-if="hasBrandExF">
            <div class="slds-form-element col slds-size--medium">
              <OutputField
                :label="$t('campaignDesigner.targetDefinition.disableOrchestration')"
                :value="disableOrchestration"
                type="checkbox"
                v-if="!(isCreate || isEdit) || !disableOrchestrationEditable" />

              <Input v-else
                :label="$t('campaignDesigner.targetDefinition.disableOrchestration')"
                type="checkbox"
                v-model="disableOrchestration" />
            </div>
          </div>
        </Card>
      </Card>
        <TabSet @updateTabIndex="selectedTab = $event.index" tab-set-id="offers_tabs" ref="tabSet" >
           <template v-if="hasBrandExP && campaign.config">
            <Tab :label="'exP Target'" id="4" position="1" :animation-name="currentAnimation" tab-set-id="offers_tabs" >
              <FiltersSet
                @applyToOtherSections="handleApplyToExFExP"
                @filterChanged="handleFilterChanged"
                ref="section_exp"
                :section-number="'4'"
                v-model="filters_exp"
                :exp="true"
                :all-brands="allBrands"
                :brands="this.expBrands"
                :hasBothExFExP="hasBrandExF && hasBrandExP"
                :config="localConfig.filters_exp"
                :isCreate="isCreate"
                :isEdit="isEdit"
                :loading="loading"
                :campaignData="campaign.campaignData"
                :userPreferences="campaign.config.userPreferences" />
            </Tab>
          </template>
          <template v-if="campaign.config && (campaign.config.userPreferences.onlyInformativeCampaign)">
            <Tab v-if="hasBrandExF" :label="'exF Target'" id="3" position="4" :animation-name="currentAnimation" tab-set-id="offers_tabs" >
              <FiltersSet
                @applyToOtherSections="handleApplyToExFExP"
                @filterChanged="handleFilterChanged"
                ref="section"
                v-model="filters"
                :section-number="'3'"
                :all-brands="allBrands"
                :brands="this.exfBrands"
                :config="localConfig.filters"
                :isCreate="isCreate"
                :isEdit="isEdit"
                :loading="loading"
                :hasBothExFExP="hasBrandExF && hasBrandExP"
                :campaignData="campaign.campaignData"
                :userPreferences="campaign.config.userPreferences" />
            </Tab>

          </template>
          <template v-else>
            <Tab v-for="(offer, index) in (this.campaign.config.offers)" :key="index" :position="`${index+2}`" :label="getSectionTitle(offer.sectionId)" :animation-name="currentAnimation" :id="offer.sectionId" tab-set-id="offers_tabs">
              <FiltersSet
                @applyToOtherSections="handleApplyToOtherSections"
                @filterChanged="handleFilterChanged($event, offer.sectionId)"
                v-model="filters[offer.sectionId]"
                :all-brands="allBrands"
                :brands="exfBrands"
                :config="localConfig.filters[offer.sectionId]"
                :isCreate="isCreate"
                :isEdit="isEdit"
                :loading="loading"
                :key="index"
                :indexKey="index"
                :original-values="getOriginalValues(offer.sectionId, index)"
                :ref="`section_${offer.sectionId}`"
                :isOffer=true
                :section-number="offer.sectionId"
                :campaignData="localConfig.campaignData"
                :userPreferences="campaign.config.userPreferences" />
            </Tab>
          </template>

        </TabSet>
      </div>

    </Card>
  </div>
</template>
<script>
import _ from 'lodash'
import { getAllData, getEmptyConfigByKey as getEmptyConfig } from '../../utils/indexedDbUtils'
import FiltersSet from './target-definition/FiltersSet'
import Card from '../../slds/Card'
import HasMode from '../../utils/HasMode'
import Spinner from '../../Spinner.vue'
import TabSet from '../../slds/tabs/TabSet'
import Tab from '../../slds/tabs/Tab'
import Picklist from '../../slds/Picklist'
import RadioGroup from '../../slds/RadioGroup'
import OutputField from '../../slds/OutputField'
import Input from '../../slds/Input'
import ManageZIPVIN from './target-definition/ManageZIPVIN'

const fieldsToCloneExP = [
'communicationChannelsFilterLogic',
'excludeContactsWithoutAssociatedDealer',
'clientType',
'marketingPrivacyConsent',
'profilingPrivacyConsent',
'firstRegistrationDate',
'warrantyExtension',
'warrantyExtensionInclude'
]

const fieldsToClone = [
  'associatedDealers',
  'clientType',
  'deduplication',
  'eligibilityUConnectLive',
  'engagementConditions',
  'maintenanceModelCluster',
  'mapCare',
  'mapCareInclude',
  'mapUpdate',
  'mapUpdateInclude',
  'marketingPrivacyConsent',
  'mileageTag',
  'monthsFromFirstRegistrationDate',
  'moparConnect',
  'moparConnectInclude',
  'orchestration',
  'profilingPrivacyConsent',
  'purchasedServicesAndAccessories',
  'registrationOnMOC',
  'tbm',
  'warrantyExtension',
  'warrantyExtensionInclude',
  'zipCodes',
  'communicationChannelsFilterLogic',
  'excludeContactsWithoutAssociatedDealer',
  'firstRegistrationDate',
  'ocfDate',
  'tbm',
  'freeMapUpdate',
  'freeMapUpdateInclude',
  'emailReactivity',
  'emailEngagement',
  'emailPressure',
]

export default {
  name: 'TargetDefinition',
  mixins: [HasMode],
  props: {
    config: Object,
    loading: Boolean,
    mode: String
  },
  components: {
    Tab,
    TabSet,
    Card,
    FiltersSet,
    Spinner,
    Input,
    OutputField,
    Picklist,
    RadioGroup,
    ManageZIPVIN
  },
  computed: {
    hasBrandExF () { //Check if brands picklist has these brands (FCA)
      //const campaign = this.callLoadFromStore()
      const brandScopes = this.$store.getters['settings/settings'].brand_per_scope
      const brands = this.campaign.config ? this.campaign.config.campaignData.campaignBrands.selected : []
      return brands.some(r=>(brandScopes[r] || []).includes('EXF'))
    },
    hasBrandExP () { //Check if brands picklist has these brands (PSA)
      //const campaign = this.callLoadFromStore()
      const brandScopes = this.$store.getters['settings/settings'].brand_per_scope
      const brands = this.campaign.config ? this.campaign.config.campaignData.campaignBrands.selected : []
      return brands.some(r=>(brandScopes[r] || []).includes('EXP'))
    },
    expBrands () {
      const brandScopes = this.$store.getters['settings/settings'].brand_per_scope
      const brands = this.campaign.config.campaignData.campaignBrands.selected
      return brands.filter(brand => (brandScopes[brand] || []).includes('EXP'))
    },
    exfBrands () {
      const brandScopes = this.$store.getters['settings/settings'].brand_per_scope
      const brands = this.campaign.config.campaignData.campaignBrands.selected
      return brands.filter(brand => (brandScopes[brand] || []).includes('EXF'))
    }
  },
  data () {
    return {
      variableLoading: true,
      showManageZipVin: false,
      allBrands: [],
      campaign: {},
      currentAnimation: 'slide-fade-right-delay',
      dealersMap: {},
      hasCustomValidation: true,
      localConfig: {},
      openSection: '',
      selectedTab: -1,
      filters: {},
      filters_exp: {},
      deduplicationEnabled: false,
      deduplicationRadioOptions: [
        {
          label: this.$t('campaignDesigner.targetDefinition.deduplication.deduplication'),
          value: 'deduplication'
        },
        {
          label: this.$t('campaignDesigner.targetDefinition.deduplication.sorting'),
          value: 'sorting'
        }
      ],
      deduplicationCriteria: '',
      deduplicationParameter: '',
      deduplicationParameterOptions: ['mostRecent', 'nearest', 'oldest'],
      disableOrchestration: false,
      disableOrchestrationEditable: true
    }
  },
  async activated () {
    this.$emit('startLoading')
    this.dealersMap = (await getAllData('clusters')).reduce((acc, val) => {
      acc[val.cluster] = val
      return acc
    }, {})
    this.callLoadFromStore()
    const emptyConfig = await getEmptyConfig('FULL')
    this.allBrands = emptyConfig.config.filters.brands.options
    this.$emit('endLoading')
  },
  methods: {
    updateZipVin (event) {
       const { mvs, mvsToExclude, vin, vinToExclude } = event.data
       //this.$emit('filterChanged', { fieldName: 'mvs', newValue: mvs, exp : this.exp })
       //this.$emit('filterChanged', { fieldName: 'mvsToExclude', newValue: mvsToExclude, exp : this.exp })
       this.$emit('filterChanged', { fieldName: 'vin', newValue: vin, exp : this.exp })
       this.$emit('filterChanged', { fieldName: 'vinToExclude', newValue: vinToExclude, exp : this.exp })
       this.showManageZipVin = false
    },
    restoreFullOffers (lightOffers) {
      const fullOffers = Object.values(this.$store.getters['campaignDesigner/state'].offers).flat()
      const offers = []

      let mapped
      if (lightOffers[0] && lightOffers[0].sectionId) {
        mapped = lightOffers
      } else {
        mapped = lightOffers.reduce((acc, val) => {
          acc.push(Object.values(val).flat())
          return acc.flat()
        }, [])
      }

      mapped.forEach(lightOffer => {
        const fullOffer = fullOffers.find(fullOffer => fullOffer.sectionId === lightOffer.sectionId)

        if (fullOffer) {
          offers.push({ ...fullOffer, tags: lightOffer.tags, contentPriority: lightOffer.contentPriority })
        }
      })

      return offers
    },
    getSelectedBrands (section) {
      if (section && typeof section === 'object') {

        let offers
        if (this.campaign.config.offers[0] && this.campaign.config.offers[0].sectionId) {
          offers = this.campaign.config.offers
        } else {
          offers = this.restoreFullOffers(this.campaign.config.offers)
        }
        const offer = offers.find(o => o.sectionId === section)
        if (offer.brand === 'All') {
          return this.campaign.config.campaignData.campaignBrands.selected
        } else {
          return [offer.brand]
        }
      } else {
        return this.$store.getters['campaignDesigner/state'].currentCampaign.brands
      }
    },
    callLoadFromStore () {
      const campaign = this.$store.getters['campaignDesigner/state'].currentCampaign
      // Orchestration/deduplication migration to third step
      this.disableOrchestration = campaign.disableOrchestration
      this.deduplicationCriteria = campaign.config.campaignData.deduplicationCriteria.selected
      this.deduplicationParameter = campaign.config.campaignData.deduplicationParameter.selected
      this.disableOrchestrationEditable = this.$store.getters['campaignDesigner/currentCampaign'].config.campaignData.disableOrchestrationEditable
      if (this.deduplicationCriteria) {
        this.deduplicationEnabled = true
      }
      //
      this.campaign = campaign
      this.localConfig = _.cloneDeep(campaign.config)
      this.filters = _.cloneDeep(campaign.config.filters)
      this.filters_exp = _.cloneDeep(campaign.config.filters_exp)
      this.variableLoading = false
      if (this.campaign.config.offers.length) {
        if (!this.campaign.config.offers[0].offerId) {
          //console.log('==========WRONG FORMAT==========', this.campaign.config.offers[0])
          let newarr = []
          for( let i = 0; i < this.campaign.config.offers.length; i++) {
            const offerid = Object.keys(this.campaign.config.offers[i])[0]
            const offerprops = this.campaign.config.offers[i][offerid][0]
            newarr.push(offerprops)
          }
          this.campaign.config.offers = newarr
        }
      }
      // if (!campaign.config.userPreferences.onlyInformativeCampaign) {
      //   this.openSection = Object.keys(this.filters)[0]
      // }
    },
    getOriginalValues (section, id) {
      let offers
      if (this.campaign.config.offers[0] && this.campaign.config.offers[0].sectionId) {
        offers = this.campaign.config.offers
      } else {
        offers = this.restoreFullOffers(this.campaign.config.offers)
      }

      const offer = offers.find(offer => offer.sectionId === section)

      const { kmFrom, kmTo, range } = offer
      return { kmFrom, kmTo, range }

    },
    getSectionTitle (section) {
      return this.campaign.config.filters[section] ? this.campaign.config.filters[section].sectionTitle : ""
    },
    getSectionToSave () {
      return {
        config: this.filters,
        config_exp: this.filters_exp,
        userPreferences: {
          privacyConsentEdited: true
        }
      }
    },
    handleApplyToOtherSections (event) {
      const { value, sectionNumber } = event

      Object.keys(_.omit(this.filters, sectionNumber)).forEach(section => {
        fieldsToClone.forEach(field => {
          if (value.hasOwnProperty(field)) {
            const o = { fieldName: field, newValue: _.cloneDeep(value[field]) }
            this.handleFilterChanged(o, section)
            this.$refs[`section_${section}`][0][field] = _.cloneDeep(value[field])
          }
        })
      })
    },
    handleApplyToExFExP (event) {
      const { value, exp } = event
      const section = exp ? 'section' : 'section_exp'
      fieldsToCloneExP.forEach(field => {
        if (value.hasOwnProperty(field)) {
          const o = { fieldName: field, newValue: _.cloneDeep(value[field]), exp: !exp }
          this.handleFilterChanged(o)
          //console.log(`For ${section}, we change field ${field} with ${value[field]}`)
          this.$refs[section][field] = _.cloneDeep(value[field])
        }
      })
    },
    handleFilterChanged ({ fieldName, newValue, exp=false, common = false }, section) {
      let filterSet
      let filterSetRef
      if (section) {
        filterSet = this.filters[section]
        filterSetRef = this.$refs[`section_${section}`][0]
      } else {
        filterSet = exp ? this.filters_exp : this.filters
        filterSetRef = exp ? this.$refs.section_exp : this.$refs.section
      }

      if (filterSet[fieldName] !== undefined && filterSet[fieldName].selected !== undefined) {
        filterSet[fieldName].selected = newValue
        if (common) this.filters[fieldName].selected = newValue
      } else {
        filterSet[fieldName] = newValue
        if (common) this.filters[fieldName] = newValue
      }

      // Additional handlers
      switch (fieldName) {
        case 'dealerCluster':
          if (newValue && newValue.length && !filterSetRef.dealers) {
            filterSetRef.dealers = {}
            newValue.forEach(dealerCluster => {
              filterSetRef.dealers[dealerCluster.toString()] = [...new Set(this.dealersMap[dealerCluster].dealers.map(dealer => dealer.idDealer))]
            })
          } else {
            const isAdded = newValue.length > Object.keys(filterSetRef.dealers || []).length
            let source, target

            if (isAdded) {
              source = newValue.map(v => v.toString())
              target = Object.keys(filterSetRef.dealers || [])
            } else {
              source = Object.keys(filterSetRef.dealers || [])
              target = newValue.map(v => v.toString())
            }

            const difference = _.differenceWith(source, target, _.isEqual)
            difference.forEach(cluster => {
              if (isAdded) filterSetRef.dealers[cluster] = [...new Set(this.dealersMap[cluster].dealers.map(dealer => dealer.idDealer))]
              else delete filterSetRef.dealers[cluster]
            })
          }

          break
      }
    },
    doValidate () {
      //EXP VALIDITY
      let exp_validity = this.hasBrandExP ? this.$refs.section_exp.validate() : true //if we dont have exp brands, be true
      if (!exp_validity) this.$refs.tabSet.setErrorTab(4, true)
      //EXF VALIDITY
      if (this.campaign.config.userPreferences.onlyInformativeCampaign) {
        const validity = this.hasBrandExF ? (this.$refs.section.validate()) : true
        if (!validity) this.$refs.tabSet.setErrorTab(3, true)
        return validity && exp_validity
      } else {
        let valid = true
        let firstInvalidTab

        Object.entries(this.$refs)
          .filter(e => e[0].includes('section'))
          .forEach(ref => {

            if (ref[0] != 'section_exp' && ref[0] != 'section') { //Ignore exp tab when looking at offers

              ref[1].forEach(subRef => {
                const isSectionValid = !!(subRef.validate())
                if (!isSectionValid && !firstInvalidTab) {
                  firstInvalidTab = subRef.$props.sectionNumber
                }
                this.$refs.tabSet.setErrorTab(parseInt(subRef.$props.sectionNumber), !isSectionValid)
                valid &= isSectionValid
              })
            }
          })

        if (firstInvalidTab) {
          const index = Object.keys(this.filters).indexOf(firstInvalidTab)
          this.$refs.tabSet.setActiveTab(index)
        }

        return valid && exp_validity
      }
    },
    validate () {
      return this.doValidate()
    }
  },
  watch: {
    deduplicationEnabled (newValue) {
      this.$store.dispatch('campaignDesigner/changeAttrInCampaignData', { attrName:'deduplicationEnabled', attrVal: newValue } )
    },
    deduplicationCriteria ( newValue ){
      let ourNewVal = { selected: newValue }
      this.$store.dispatch('campaignDesigner/changeAttrInCampaignData', { attrName:'deduplicationCriteria', attrVal: ourNewVal } )
    },
    deduplicationParameter ( newValue ){
      let ourNewVal = { options: this.deduplicationParameterOptions ,selected: newValue }
      this.$store.dispatch('campaignDesigner/changeAttrInCampaignData', { attrName:'deduplicationParameter', attrVal: ourNewVal } )
    },
    disableOrchestration ( newValue ){
      this.$store.dispatch('campaignDesigner/changeAttrInFlatCampaign', { attrName:'disableOrchestration', attrVal: newValue } )
    },
    selectedTab (newTab, oldTab) {
      if (newTab > oldTab) {
        this.currentAnimation = 'slide-fade-left-delay'
      } else {
        this.currentAnimation = 'slide-fade-right-delay'
      }
    },
    openSection (newSection, oldSection) {
      const newIndex = this.campaign.config.offers.findIndex(offer => offer.sectionId === newSection)
      const oldIndex = this.campaign.config.offers.findIndex(offer => offer.sectionId === oldSection)

      if (newIndex > oldIndex) {
        this.currentAnimation = 'slide-fade-left'
      } else {
        this.currentAnimation = 'slide-fade-right'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .slds-card {
    height: 100%;
    overflow-y: auto;
  }

  Input {
    width: unset !important;
  }
</style>
